import { render, staticRenderFns } from "./ele13.vue?vue&type=template&id=056fb9ef&scoped=true"
import script from "./ele13.vue?vue&type=script&lang=js"
export * from "./ele13.vue?vue&type=script&lang=js"
import style0 from "./ele13.vue?vue&type=style&index=0&id=056fb9ef&prod&lang=scss"
import style1 from "./ele13.vue?vue&type=style&index=1&id=056fb9ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056fb9ef",
  null
  
)

export default component.exports